import Sound from "./sound.js";

class audio {
  constructor() {
    const path = "src/sounds/";
    this.sounds = {
      error: path + "erro.mp3",
      beep: path + "beep.wav",
      bot: path + "bot.ogg",
      alarm: path + "alarm.mp3",
      notification: path + "notification.mp3"
    };
    this.sound = new Sound();
  }

  play (s, loop = false) {
    this.sound.audio.loop = loop;
    this.sound.src(s);
    this.sound.play();
  }

  error (loop = false) {
    this.play(this.sounds.error, loop);
  }

  beep (loop = false) {
    this.play(this.sounds.beep, loop);
  }

  bot (loop = false) {
    this.play(this.sounds.bot, loop);
  }

  notification (loop = false) {
    this.play(this.sounds.notification, loop);
  }

  alarm (loop = true) {
    this.play(this.sounds.alarm, loop);
  }

  stop () {
    this.sound.pause();
  }
}

export default new audio();
